/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

import { ScreenAwareElement } from './screen-aware-element.js';
import { getDesktopFabHostTemplate, getSpacerTemplate } from './template-helpers.js';

const DEFAULT_SPACER_HEIGHT = 16;

export class PageViewElement extends ScreenAwareElement {
  // Only render this page if it's actually visible.
  shouldUpdate() {
    return this.active;
  }

  static get properties() {
    return {
      active: { type: Boolean },
      spacerHeight: { type: Number}
    }
  }

  constructor() {
		super();
    this.spacerHeight = 0;
  }

  getDesktopFabHostTemplate_() {
		return this.largeScreen? getDesktopFabHostTemplate() : '';
	}

  getSpacerTemplate_(offset = DEFAULT_SPACER_HEIGHT) {
    return this.largeScreen? '' : getSpacerTemplate(this.spacerHeight + offset);
  }
}
